import { render, staticRenderFns } from "./UpdateDriver.vue?vue&type=template&id=d4b77606&"
import script from "./UpdateDriver.vue?vue&type=script&lang=js&"
export * from "./UpdateDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports